(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dheart-contact-widget"]) return;
  try {
    
  const contactWidget = document.querySelector('.dh-contact-widget');
  if (contactWidget) {
    document.addEventListener('click', (event) => {
      if (contactWidget.open && !contactWidget.contains(event.target)) contactWidget.open = false;
    });
    contactWidget.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      contactWidget.open = false;
      contactWidget.querySelector('summary').focus();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dheart-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dheart-editorial-player')) {
  customElements.define('dheart-editorial-player', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      const poster = this.querySelector('.dh-editorial__poster');
      const video = this.querySelector('.dh-editorial__video');
      poster.addEventListener('click', () => {
        video.replaceChildren(this.querySelector('template').content.cloneNode(true));
        dialog.showModal();
      });
      this.querySelector('.dh-editorial__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { video.replaceChildren(); poster.focus(); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dheart-faq"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dheart-faq'))customElements.define('dheart-faq',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.querySelectorAll('details').forEach(item=>item.addEventListener('toggle',()=>{
   item.querySelectorAll('.dh-faq__video').forEach(video=>{
    const frame=video.querySelector('.dh-faq__embed');
    if(item.open&&!frame.firstChild)frame.append(video.querySelector('template').content.cloneNode(true));
    if(!item.open)frame.replaceChildren();
   });
  }));
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dheart-patients"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dheart-patients'))customElements.define('dheart-patients',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.events=new AbortController();
  const track=this.querySelector('.dh-patients__slides'),buttons=[...this.querySelectorAll('[data-direction]')];
  const update=()=>{buttons[0].disabled=track.scrollLeft<2;buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
  buttons.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.direction)*(track.firstElementChild.getBoundingClientRect().width+30),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}),{signal:this.events.signal}));
  track.addEventListener('scroll',update,{passive:true,signal:this.events.signal});this.observer=new ResizeObserver(update);this.observer.observe(track);update();
 }
 disconnectedCallback(){this.events?.abort();this.observer?.disconnect();this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dheart-scanner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dh-scanner-gallery')) {
  customElements.define('dh-scanner-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', event => {
          const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(next);
          this.tabs[next].focus();
        });
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[role="tabpanel"]');
        if (panel) this.select(this.tabs.findIndex(tab => tab.getAttribute('aria-controls') === panel.id));
      });
    }
    select(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.querySelector('#' + tab.getAttribute('aria-controls')).hidden = i !== index;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dheart-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dheart-story-player'))customElements.define('dheart-story-player',class extends HTMLElement{
 connectedCallback(){const poster=this.querySelector('button');if(!poster||this.ready)return;this.ready=true;poster.addEventListener('click',()=>{poster.replaceWith(this.querySelector('template').content.cloneNode(true));this.querySelector('iframe')?.focus();},{once:true});}
});

  } catch(e) { console.error(e); }
})();
})();
